import react from "react";
import { MdTitle } from "react-icons/md";
import { Link } from "react-router-dom";
import { MdNavigateNext } from "react-icons/md";

function RowTitles({ title, child }) {
  return (
    <div className="row">
      <p>
        <Link
          to="/"
          className="text-secondary"
          style={{ textDecoration: "none" }}
        >
          {title}
        </Link>{" "}
        <MdNavigateNext />{" "}
        <small>
          <b className="text-secondary">{child} </b>
        </small>
      </p>
    </div>
  );
}
export default RowTitles;
